module.exports = __webpack_public_path__ + "static/img/1.51e3e6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/1.jpg
// module id = tWwK
// module chunks = 12